import { type RadixDropdownItemProps } from './types'

/**
 * Generates a CSS class string based on the active state.
 *
 * @param {boolean} active - Whether the dropdown item is active
 * @returns {string} CSS class string for the active state
 */
export const dropdownActiveClass = (active: boolean): string => (active ? 'bg-primary-700' : '')

/**
 * Generates a radix dropdown item configuration object.
 *
 * @param {Object} params - The parameters for generating the dropdown item
 * @param {() => void} params.onSelect - Callback function when the item is selected
 * @param {JSX.Element} params.component - React component to render as the dropdown item
 * @param {Object} params.props - Additional properties to pass to the dropdown item
 * @returns {RadixDropdownItemProps} Configuration object for the dropdown item
 */
export const generateRadixDropdownItem = ({
  onSelect,
  component,
  ...props
}: {
  onSelect: (e: Event) => void
  component: JSX.Element
  [key: string]: any
}): RadixDropdownItemProps => ({
  type: 'item',
  ...props,
  onSelect,
  asChild: true,
  component
})
